// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2VLQW","content":"Consent_content__2p_XH","footer":"Consent_footer__j4gUr"};